var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDangerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14996 0.600098L0.399963 4.3501V9.6501L4.14996 13.4001H9.44996L13.2 9.6501V4.3501L9.44996 0.600098H4.14996ZM12 9.1541L8.95396 12.2001H4.64616L1.60016 9.1541V4.8463L4.64616 1.8003H8.95396L12 4.8463V9.1541Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 4H7.39995V7.2H6.19995V4Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 8.80029H7.39995V10.0003H6.19995V8.80029Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDangerOutline);
export default __webpack_public_path__ + "static/media/Icon-danger-outline.3a9f2c95.svg";
export { ForwardRef as ReactComponent };